import React, {useCallback, useEffect, useRef, useState} from "react"
import {LexicalEditor} from "lexical"
import PopupMenuButton from "../../../../../popover-menu/popup-menu-button/popup-menu-button"
import ToolbarInsertButton from "./insert-button"
import ToolbarInsertMenu from "./insert-menu"
import {findDOMNode} from "react-dom";

type Props = {
    editor: LexicalEditor
}

const MINIMIZE_THRESHOLD_WIDTH = 50
const MAXIMIZE_THRESHOLD_WIDTH = 28

const debug = false
// const debug = "InsertToolbar"

export default function InsertToolbar(props: Props): JSX.Element {

    const [isMinimized, setIsMinimized] = useState(false)

    const elementRef: any = useRef()

    const onWidthChanged = useCallback(()=>{
        const node:any = findDOMNode(elementRef.current)
        if (!node) return

        debug && console.log(debug, 'onWidthChanged', isMinimized, node.offsetWidth,
            node.offsetWidth > MAXIMIZE_THRESHOLD_WIDTH,
            node.offsetWidth < MINIMIZE_THRESHOLD_WIDTH)

        if (isMinimized) {
            if (node.offsetWidth > MAXIMIZE_THRESHOLD_WIDTH) {
                setIsMinimized(false)
            }
        } else {
            if (node.offsetWidth < MINIMIZE_THRESHOLD_WIDTH) {
                setIsMinimized(true)
            }
        }
    }, [isMinimized])

    useEffect(() => {
        const unsubscribe = gd.bus.subscribeNoContext('lexical-toolbar:width-changed', onWidthChanged)
        return () => {
            unsubscribe()
        }
    }, [isMinimized])

    return (
        <PopupMenuButton ref                = {elementRef}
                         className          = "insert-toolbar"
                         style              = {{minWidth: MAXIMIZE_THRESHOLD_WIDTH}}
                         hint               = "Insert"
                         btnComponent       = {(state:any,props:any)=><ToolbarInsertButton {...props} {...state} isMinimized={isMinimized}/>}
                         menuComponent      = {ToolbarInsertMenu}
                         menuParams         = {{
                             editor: props.editor
                         }}/>
    )
}